import styled from "styled-components";

export const TicketVideoCallContainer = styled.div`
	align-items: center;
	background-color: ${(props) => props.theme.yourTurnBackgroundColor};
	border-radius: 16px;
	box-shadow: 0px 10px 40px rgba(18, 18, 18, 0.1);
	color: #fff;
	display: flex;
	flex-direction: column;
	height: 592.43px;
	justify-content: center;
	max-width: 1000px;
	padding: 1rem;
	text-align: center;
	width: 100%;
	margin-top: 1rem;

	.ticket__videoCall-logo {
		display: none;
		margin: 0.8rem;
		max-height: 60px;
	}

	.ticket__videoCall-title {
		font-weight: 500;
		font-size: 20px;
	}

	.ticket__videoCall-mainText {
		font-weight: 700;
		font-size: 40px;
		color: #fff;
	}

	.ticket__videoCall-joinBtn {
		background-color: #fff;
		color: #000;
		font-size: 20px;
		font-weight: 600;
		max-width: 528px;
		border-radius: 4px;
		padding: 1rem 4rem;
		cursor: pointer;
		margin: 2rem;
	}
	.ticket__videocall-bottomText {
		font-weight: 400;
		font-size: 16px;

		span {
			font-weight: 700;
		}
	}
	img {
		width: 186px;
	}

	@media (max-width: 768px) {
		margin-top: 0;
		height: 100%;
		border-radius: 0;

		.ticket__videoCall-logo {
			display: block;
		}
	}
	@media (max-width: 648px) {
		margin-top: 0;
		.ticket__videoCall-mainText {
			font-size: 32px;
		}
		.ticket__videoCall-joinBtn {
			font-size: 16px;
		}
	}
`;
